import type { IObjectViewModel } from '../../../interfaces';
import { SceneItemKind } from '../../../interfaces';
import type { IIndicationStrategy } from '../Indications.controller';
import type { IIndicationToolFactory } from '../Indications.factory';
import type { IndicationsService } from '../Indications.service';
import type { IValue } from '@/engine/DataFlow/Graph';
import { AnnotationModel } from './Annotation.model';
import { AnnotationStrategy } from './AnnotationStrategy';
import type { IIndicationsViewModelFactory } from '../interfaces';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';
import type { ICommandProcessor } from '../../core/interfaces/Command';
import type { IRemover } from '@/engine/UIPresentation/Interfaces';
import { BaseIndicationAdder } from '../distance/BaseIndicationAdder';

export class AnnotationToolFactory implements IIndicationToolFactory {
  private readonly _baseIndicationLabel = 'Annotation';

  private readonly _indicationsService: IndicationsService;

  public constructor(indicationsService: IndicationsService) {
    this._indicationsService = indicationsService;
  }

  public createIndicationStrategy(
    planningAlgorithm: PlanningAlgorithm,
    commandProcessor: ICommandProcessor,
    remover: IRemover
  ): IIndicationStrategy {
    return new AnnotationStrategy(
      this._indicationsService,
      planningAlgorithm,
      commandProcessor,
      new BaseIndicationAdder(planningAlgorithm, this._indicationsService),
      remover
    );
  }

  public createIndicationModel(): IValue {
    return new AnnotationModel({});
  }

  public createIndicationViewModel(
    vmFactory: IIndicationsViewModelFactory,
    phaseId: string | undefined
  ): IObjectViewModel {
    return vmFactory.createViewModel(
      SceneItemKind.IndicatedAnnotation,
      phaseId,
      undefined,
      undefined,
      this._indicationsService.getIndicationLabel(this._baseIndicationLabel, SceneItemKind.IndicatedAnnotation)
    );
  }
}
